module.exports = __webpack_public_path__ + "static/8sec-a4aebf481b16e33830ca78400552a592.svg";